import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ROLES } from 'src/app/app.constants';
import { AuthService } from './auth.service';

export const ScopeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const logger = inject(NGXLogger);
  const router = inject(Router);

  const expectedScopes = route.data['scopes'] as string[];
  if (!expectedScopes.length) {
    logger.trace('ScopeGuard: no scopes required');
    return true;
  }

  logger.trace('ScopeGuard: scopes required', expectedScopes);

  const user = authService.currentUser;
  if (!!user && user.scopes.includes(ROLES.systemAdministrators)) {
    logger.trace('ScopeGuard: user has admin scope');
    return true;
  }

  if (!!user && user.scopes.some(scope => expectedScopes.includes(scope))) {
    logger.trace('ScopeGuard: user has required scopes');
    return true;
  }

  logger.trace('ScopeGuard: user does not have required scopes');
  return router.parseUrl('/error/403');
}
